import { render, staticRenderFns } from "./m-tip.vue?vue&type=template&id=151f2718&scoped=true&"
import script from "./m-tip.vue?vue&type=script&lang=js&"
export * from "./m-tip.vue?vue&type=script&lang=js&"
import style0 from "./m-tip.vue?vue&type=style&index=0&id=151f2718&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f2718",
  null
  
)

export default component.exports